<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtroText" placeholder="Filtrar por produto..." @keyup.native.enter="loadingItens"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button type="primary" @click="openDialog()">NOVO ITEM</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Produto</th>
            <th class="hidden-mobile u-text-center">Quantidade</th>
            <th class="hidden-mobile u-text-right">Vlr unit.</th>
            <th class="hidden-mobile u-text-right">Vlr total</th>
            <th style="width: 150px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in itensFiltrados" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.produto ? item.produto.nome : ('#' + item.produto_id) }}</td>
            <td class="hidden-mobile u-text-center">{{ item.quantidade }}</td>
            <td class="hidden-mobile u-text-right">{{ formatMoney(item.valor_unitario) }}</td>
            <td class="hidden-mobile u-text-right">{{ formatMoney(item.valor_total) }}</td>
            <td class="u-text-center acao">
              <el-button @click="openDialog(item)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>
    </div>

    <el-dialog append-to-body :title="dialogEdit ? 'Editar Item' : 'Novo Item'" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-form :model="form" ref="form" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Produto" prop="produto_id" :rules="[$requiredChange]" key="produto_id">
              <el-select v-model="form.produto_id" placeholder="pesquisar..." filterable remote :remote-method="getProdutoByFilter" :loading="loadingProduto">
                <el-option v-for="item in produtos" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Quantidade" prop="quantidade" :rules="[$requiredBlur]" key="quantidade">
              <el-input v-model="form.quantidade"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor unitário" prop="valor_unitario" :rules="[$requiredBlur]" key="valor_unitario">
              <el-input v-model="form.valor_unitario"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor total" prop="valor_total" :rules="[$requiredBlur]" key="valor_total">
              <el-input v-model="form.valor_total"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">CANCELAR</el-button>
        <el-button type="primary" @click="saveItem">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtroText: '',
    itens: [],
    dialogVisible: false,
    dialogEdit: false,
    loadingProduto: false,
    produtos: [],
    form: {
      id: '',
      gasto_id: '',
      produto_id: '',
      quantidade: '',
      valor_unitario: '',
      valor_total: ''
    }
  }),
  mounted () {
    this.loadingItens()
  },
  computed: {
    gastoId () {
      return this.$route.params.gasto_id
    },
    itensFiltrados () {
      if (!this.filtroText) return this.itens
      const q = String(this.filtroText).toLowerCase()
      return this.itens.filter(i => (i.produto && i.produto.nome ? i.produto.nome : '').toLowerCase().includes(q))
    }
  },
  methods: {
    loadingItens () {
      this.statusList = false
      this.itens = []
      const filtro = { gasto_id: this.gastoId }
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto-item/getAllPaginate?page=1`, filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.itens = response.data.data
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    openDialog (item = null) {
      this.dialogVisible = true
      this.dialogEdit = !!item
      if (item) {
        this.form = Object.assign({}, item)
      } else {
        this.form = { id: '', gasto_id: this.gastoId, produto_id: '', quantidade: '', valor_unitario: '', valor_total: '' }
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    getProdutoByFilter (query) {
      if (!query || query.length < 2) {
        this.produtos = []
        return false
      }
      this.loadingProduto = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/produto/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.produtos = JSON.parse(JSON.stringify(response.data))
        this.loadingProduto = false
      }).catch((error) => { this.loadingProduto = false; this.$store.commit('throwException', error) })
    },
    saveItem () {
      this.$refs.form.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const payload = Object.assign({}, this.form, { gasto_id: this.gastoId })
        if (this.dialogEdit) {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto-item/update/` + payload.id, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        } else {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto-item/store`, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
      })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este item?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto-item/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

